import React from 'react';
import { FormContainer } from '../../common/form/FormContainer';
import FormItem from '../../common/form/FormItem';
import FormWidget from '../../common/form/FormWidget';
import FormPanel from '../../common/form/FormPanel';

export default () => {
    return (
        <FormPanel>
            <FormContainer>
                <FormItem>
                    <FormWidget name="label" label="Label" />
                </FormItem>
                <FormItem>
                    <FormWidget name="group" label="Group" />
                </FormItem>
                <FormItem>
                    <FormWidget name="description" component="TextArea" label="Description" />
                </FormItem>
            </FormContainer>
        </FormPanel>
    );
};
